// extracted by mini-css-extract-plugin
export var multipleDynamicContainer = "MultipleDynamic_multipleDynamicContainer__nSWDM";